/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react'
import { AnimatePresence } from 'framer-motion'
import Overlay from '@/core/components/modal/modal-topbar/overlay'
import { LinkSimple, PushPin } from '@phosphor-icons/react'
import UserDropdown from './user-dropdown'
import TransactionButtons from './transaction-buttons'
import { useOpenAggregatorModal } from '@/core/hooks/aggregator/useOpenAggregatorModal'
import { useTranslation } from 'react-i18next'

export default function Header() {
  const { t } = useTranslation()
  const buttonRefs = useRef<any[]>([])
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [modalData, setModalData] = useState<React.JSX.Element>()
  const [isAggregatorOpen, setIsOpenAggregator] = useOpenAggregatorModal()

  useEffect(() => {
    if (!isAggregatorOpen) {
      closeModal(false)
    }
  }, [isAggregatorOpen])

  const closeModal = (e: any) => {
    e && e.preventDefault()
    buttonRefs.current.forEach((item) => {
      item.classList.remove('active')
    })
    setModalOpen(false)
  }
  const openModal = (modal: React.JSX.Element) => {
    if (modalOpen) {
      buttonRefs.current.forEach((item) => {
        item.classList.remove('active')
      })
      setModalOpen(false)
    } else {
      setModalOpen(true)
      setModalData(modal)
    }
  }

  return (
    <>
      <header className={`header ${modalOpen ? 'hide-shadow' : ''}`}>
        <div className="header-topbar">
          <TransactionButtons />
          <UserDropdown />
        </div>
      </header>

      <AnimatePresence>
        {modalOpen && (
          <Overlay close={closeModal}>{modalData ? modalData : <></>}</Overlay>
        )}
      </AnimatePresence>
    </>
  )
}
